import styled from 'styled-components';

export const BluePrintStyled = styled.div`
  width: 100%;
  padding: 30px 20px;
`;
export const ContainerStyled = styled.div`
  max-width: 1450px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;

  .main-text {
    display: flex;
    flex-direction: column;
    gap: 30px;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    & .text p {
      font-size: 20px;
      line-height: 32px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 29px;
        line-height: 45px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        font-size: 32px;
        line-height: 50px;
      }
    }

    & .title {
      line-height: 25px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        line-height: 27px;
      }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      align-items: flex-start;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    align-items: flex-start;
    gap: 90px;
  }
`;

export const DetailsStyled = styled.div`
  display: flex;
  padding: 30px 20px;
  gap: 15px;

  .main-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;
